import styled from "styled-components"
import media from "src/styles/media"

export const ContactFormWrapper = styled.form`
  max-width: 440px;
  margin: auto;

  ${media.lessThan("lg")`
         display: none;
    `}

  .form-result {
    margin-top: -10px;
    padding-left: 12px;
    max-width: 80%;
  }
`
